import React, { useState, useEffect } from 'react';
import LocalFilersWithUnfiledReports from './components/LocalFilersWithUnfiledReports';

import LitigationDeadlines from './components/LitigationDeadlines';

import { Grid, CssBaseline, Box, Tab, Tabs, AppBar, ButtonBase, Toolbar, Typography } from '@mui/material/';
import ExtranetLogo from '../../components/nav/ExtranetLogo';
import './view-nonfiler-tracker-styles.css';

function NonfilerTrackerApp() {
    interface TabPanelProps {
        children?: React.ReactNode;
        index: number;
        value: number;
    }

    function CustomTabPanel(props: TabPanelProps) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{children}</Box>}
            </div>
        );
    }

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
   
    return (
        <div>
            <Grid container sx={{ display: 'flex' }}>
                <CssBaseline />
                <Grid item xs={12}>
                    {/* top navigation bar */}
                    <AppBar
                        enableColorOnDark
                        position="static"
                        color="inherit"
                        elevation={0}
                        sx={{
                            bgcolor: '',
                            transition: 'none'
                        }}
                        className="top-navbar"
                    >
                        <Toolbar>
                            <Box
                                sx={{
                                    width: 228,
                                    display: 'flex',
                                }}
                            >
                                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                                    <ButtonBase>
                                        <ExtranetLogo></ExtranetLogo>
                                    </ButtonBase>
                                </Box>
                            </Box>

                            <Box sx={{ flexGrow: 2 }} style={{ marginTop: 10 }}>
                                <Typography variant="h6" sx={{ color: '#0288d1', fontWeight: 'bold' }}>
                                    Local Filer Tracker
                                </Typography>
                            </Box>
                        </Toolbar>
                    </AppBar>
                </Grid>
            </Grid>
                

            
            <Box sx={{borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs">
                    <Tab label="Unfiled Reports" {...a11yProps(0)} />
                    <Tab label="Litigation" {...a11yProps(1)} />
                </Tabs>
            </Box>
                
            <CustomTabPanel  value={value} index={0}>
                <LocalFilersWithUnfiledReports />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <LitigationDeadlines />
            </CustomTabPanel>
            
                
            
  
        </div>
    );
}

export default NonfilerTrackerApp;